import { Navigate, useLocation } from 'react-router';
import { BookingForm } from '../Booking';
import { BookingContextProvider } from '../BookingContext';
import { getQueryParams } from '../utils/urlUtils';

interface SearchParams {
  hotelId: string;
}

export const Home = () => {
  const location = useLocation();
  const search = getQueryParams<SearchParams>(location.search);

  if (search?.hotelId) {
    return <Navigate to={`/embed/${search.hotelId}`} replace />;
  }

  return (
    <BookingContextProvider>
      <BookingForm />
    </BookingContextProvider>
  );
};
